export const services = [
  {
    slug: 'economic-studies',
    title: 'Economic Studies and Consultation',
    description:
      'Economic and industrial research, consulting services, and feasibility studies in both macro and micro economics.',
    icon: 'LineChart',
  },
  {
    slug: 'oil-gas',
    title: 'Oil & Gas and Petrochemical',
    description:
      'Supply, install, commissioning, and maintenance of industrial steam boilers, pumps, valves, compressors, sootblowers, gearboxes, instrumentation, and chemicals including catalyst.',
    icon: 'Droplets',
  },
  {
    slug: 'power-energy-water',
    title: 'Power, Energy, and Water Industries',
    description:
      'Supply, install, commissioning, and maintenance of steam boilers, HRSG, electrical motors, transformers, breakers, switchgears, pumps, valves, sootblowers, steel pipes, turbine spare parts and control systems, instrumentation, and control panels.',
    icon: 'Zap',
  },
  {
    slug: 'radiation-monitoring',
    title: 'Radiation Monitoring and Control',
    description:
      'From concept of design to turnkey project, including operating, training, and maintenance.',
    icon: 'Radio',
  },
  {
    slug: 'laboratory',
    title: 'Laboratory Services',
    description:
      'Supply, install, and commissioning of a wide range of laboratory equipment and machines, including nuclear measurement solutions, radiation detection systems, and radiation protection systems.',
    icon: 'FlaskConical',
  },
  {
    slug: 'management-control',
    title: 'Management and Control',
    description:
      'Supplying industrial sectors with the solutions, devices, equipment, and software needed to control and manage their processes.',
    icon: 'SlidersHorizontal',
  },
  {
    slug: 'mineral-industries',
    title: 'Mineral Industries',
    description:
      'Supply, install, commissioning, and maintenance of materials handling systems (pneumatic solutions) for cement, steel, ferrous and nonferrous, and other general materials industries.',
    icon: 'Factory',
  },
  {
    slug: 'meteorological',
    title: 'Meteorological Sector',
    description:
      'Supply, install, and maintain surface and upper-air systems and instruments, hydrogen generators, seismology systems, and rain enhancement systems.',
    icon: 'CloudSun',
  },
];
